import { min } from 'lib/array/arrayUtils'

export function getPropertyRateDisplayPrice(rate: App.EnrichedPropertyRate): number {
  return rate.luxPlusTotals?.displayPrice ?? rate.totals.displayPrice
}

export function getCheapestDisplayPriceRate(
  rates: Array<App.EnrichedPropertyRate>,
): App.EnrichedPropertyRate | undefined {
  return min(rates, getPropertyRateDisplayPrice)
}

export function hasLuxPlusDisplayPrice(rate: App.EnrichedPropertyRate | undefined): boolean {
  return !!rate?.luxPlusTotals?.displayPrice
}

export function canShowCollapsedLeadPrice(rate: App.EnrichedPropertyRate | undefined): boolean {
  return !!rate && (
    !rate.includesFlights ||
    (typeof rate.cheapestFlightPrice === 'number' && rate.cheapestFlightPrice > 0)
  )
}
